import { createContext } from 'react';

export const NoPermissionContext = createContext({});
